import { getDialingCodeByISOCode } from 'lib/utils/dialingCodeList';
import * as CdpService from '../../../services/CdpService';
import { removeFromBlockList } from '../../../lib/utils/axiosFetcher';
export const sendWelcomeSms = async (smsExtensionData: any): Promise<boolean> => {
  try {
    const sendSmsEvent = process.env.NEXT_PUBLIC_CDP_SENDSMS_EVENT as string;
    await CdpService.event(sendSmsEvent, smsExtensionData);
    return true;
  } catch (error) {
    return false;
  }
};

export const unblockUserSMS = async (
  siteSettings: any,
  countryISO2: any,
  ContactNumber: any,
  cdpPayload: any
): Promise<boolean> => {
  try {
    const isSendSmsEnabled = siteSettings?.enableSmsSendFeature?.value;

    const transactionalFromNumber = siteSettings?.transactionalFromNumber?.value;

    if (isSendSmsEnabled && transactionalFromNumber && ContactNumber) {
      const dialingCode =
        countryISO2 != null && countryISO2 !== '' ? getDialingCodeByISOCode(countryISO2) : '+1';
      const formatNumber = (num: string) => (num?.indexOf('+') > -1 ? num : `${dialingCode}${num}`);

      const shouldUnblock =
        ((cdpPayload?.secondaryConsentInfo?.isSecondaryConsentAccepted ||
          cdpPayload?.secondaryConsentInfo?.combinedConsentAccepted) &&
          cdpPayload?.secondaryConsentInfo?.isSecondaryContactMediumSms === 'Yes') ||
        (cdpPayload?.consentInfo?.isPrivacyPolicyAccepted &&
          cdpPayload?.consentInfo?.isContactMediumSms === 'Yes');

      if (shouldUnblock) {
        const unblockSMSPayload = {
          FromNumber: formatNumber(transactionalFromNumber),
          ToNumber: formatNumber(ContactNumber),
        };
        removeFromBlockList(unblockSMSPayload);
      }
    }
    return true;
  } catch (error) {
    return false;
  }
};
